{
	"termsAndConditions": {
		"title": "Общи условия",
		"submitTitle": "Приемам и продължавам към Политиката за поверителност"
	},
	"privacyPolicy": {
		"title": "Политика за поверителност",
		"submitTitle": "Приемам и затварям",
		"backTitle": "Назад"
	}
}
